import ReactLogo from "../../pics/ReactLogo.png";
import NextjsLogo from "../../pics/next-js-icon-logo-EE302D5DBD-seeklogo.com.png";
import expressLogo from "../../pics/expressjs_logo_icon_169185.png";
import ElectronLogo from "../../pics/Electron_Software_Framework_Logo.png";
import MongoDBLogo from "../../pics/mongodbLogo.png";
import NodejsLogo from "../../pics/node-js-icon-227x256-913nazt0.png";
import PostmanLogo from "../../pics/postman-logo-0087CA0D15-seeklogo.com.png";
import FigmaLogo from "../../pics/FigmaLogo.png";
import AILogo from "../../pics/Adobe_Illustrator_Icon_CS6.png";
import PSLogo from "../../pics/Adobe_Photoshop_CS6_icon.png";
import Css3Logo from "../../pics/CSS3_logo.png";
import JavaScriptLogo from "../../pics/JavaScript_logo.png";
import HTML5_Logo from "../../pics/HTML5_logo_and_wordmark.png";
import firebaseLogo from "../../pics/firebase_logo.png";
import typeScriptLogo from "../../pics/typescript_original_logo_icon_146317.png";
import gatsbyLogo from "../../pics/gatsby-logo-1A245AD37F.png";

const MainTechs = [
  {
    title: "ReactJS",
    icon: <img src={ReactLogo} alt="" className="imgStyle" />,
    description:
      "I've worked on over 20 projects, employing the ReactJS framework to bring system designs and logic to life.",
    path: "",
    category: "Javascript/Typescript",
  },
  {
    title: "NextJS",
    icon: <img src={NextjsLogo} alt="" className="imgStyle" />,
    description:
      "Next.js has been my go-to framework for delivering fast server-side data rendering in over 10 projects I've worked on.",
    path: "",
    category: "Javascript/Typescript",
  },
  {
    title: "NodeJS",
    icon: <img src={NodejsLogo} alt="" className="imgStyle" />,
    description:
      "40+ projects built on the Node.js platform, which doubles as the runtime environment for executing and validating JavaScript applications",
    path: "",
    category: "Runtime Environment",
  },
  {
    title: "ElectronJS",
    icon: <img src={ElectronLogo} alt="" className="imgStyle" />,
    description:
      "I've developed Electron-powered desktop applications for both Windows and Linux, with a total of three or more projects in my portfolio.",
    path: "",
    category: "Javascript/Typescript",
  },
  {
    title: "ExpressJS",
    icon: <img src={expressLogo} alt="" className="imgStyle" />,
    description:
      "I've successfully delivered eight or more projects, utilizing ExpressJS as the key back-end server language, in collaboration with several open-source libraries",
    path: "",
    category: "Javascript/Typescript",
  },
  {
    title: "MongoDB",
    icon: <img src={MongoDBLogo} alt="" className="imgStyle" />,
    description:
      "My portfolio includes more than 30 projects where MongoDB was employed as the primary database, storing data in NoSQL document structures.",
    path: "",
    category: "Database",
  },
  {
    title: "Postman",
    icon: <img src={PostmanLogo} alt="" className="imgStyle" />,
    description:
      "My standard practice includes initial endpoint testing using Postman to guarantee the robustness of GET, POST, PATCH, PUT, DELETE functionalities.",
    path: "",
    category: "API Testing",
  },
  {
    title: "Figma",
    icon: <img src={FigmaLogo} alt="" className="imgStyle" />,
    description:
      "I begin the UI design process by creating prototypes in Figma before moving to development.",
    path: "",
    category: "UI/UX",
  },
  {
    title: "Illustrator",
    icon: <img src={AILogo} alt="" className="imgStyle" />,
    description:
      "The use of Illustrator extends to designing mockups, icons, calendars, posters, and other graphic content, typically exported in SVG and PDF formats.",
    path: "",
    category: "UI/UX",
  },
  {
    title: "PhotoShop",
    icon: <img src={PSLogo} alt="" className="imgStyle" />,
    description:
      "In the realm of web design, Photoshop is the tool of choice for crafting attractive graphics, including web page elements, calendars, invitations, logos, and more.",
    path: "",
    category: "UI/UX",
  },
  {
    title: "CSS",
    icon: <img src={Css3Logo} alt="" className="imgStyle" />,
    description:
      "My portfolio includes more than 40 projects in which I've harnessed CSS to craft layouts, animations, color palettes, and stylistic elements.",
    path: "",
    category: "UI Design",
  },
  {
    title: "HTML",
    icon: <img src={HTML5_Logo} alt="" className="imgStyle" />,
    description:
      "In all my 60+ projects, I relied on HTML as the fundamental language for building web page structures.",
    path: "",
    category: "Frontend Core",
  },
  {
    title: "JavaScript",
    icon: <img src={JavaScriptLogo} alt="" className="imgStyle" />,
    description:
      "JavaScript has been the cornerstone of my work, powering over 30 projects aimed at delivering dynamic and interactive web content.",
    path: "",
    category: "Programming Language",
  },
  {
    title: "TypeScript",
    icon: <img src={typeScriptLogo} alt="" className="imgStyle" />,
    description:
      "I've harnessed TypeScript in 30+ projects to empower the development of web applications with dynamic and interactive features.",
    path: "",
    category: "Programming Language",
  },
  {
    title: "Firebase Cloud",
    icon: <img src={firebaseLogo} alt="" className="imgStyle" />,
    description:
      "I have experience in utilizing Firebase Cloud Firestore to store and manage NoSQL data while implementing robust security measures.",
    path: "",
    category: "Cloud Database",
  },
  {
    title: "Gatsby",
    icon: <img src={gatsbyLogo} alt="" className="imgStyle" />,
    description:
      "I have leveraged Gatsby to create high-performance, static, and dynamic websites with seamless content integration and blazing-fast load times",
    path: "",
    category: "React and GraphQL",
  },
];
export default MainTechs;
